module.exports = __webpack_public_path__ + "static/img/reward4.c3aab0fe.png";